<igx-hierarchical-grid #kidsGrid primaryKey="id" [height]="'500px'" [data]="this.kids | sorting" igxGridState
    [moving]="true" (columnMoving)="columnMoving($event)">
    <igx-grid-toolbar>
        <igx-grid-toolbar-actions>
            <button igxButton igxRipple (click)="addKid(kidForm, dialog)">Добави дете</button>
        </igx-grid-toolbar-actions>
    </igx-grid-toolbar>
    <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
        <ng-template igxCell let-cell="cell">
            <button title="Запиши за програма" igxIconButton="flat" (click)="addPackage(cell, addProgram)">
                <igx-icon>downhill_skiing</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
        <ng-template igxCell let-cell="cell">
            <button title="Редактирай" igxIconButton="flat" (click)="updateKid(kidForm, dialog, cell)">
                <igx-icon>edit</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
        <ng-template igxCell let-cell="cell">
            <button title="Преглед" igxIconButton="flat" (click)="getInfo(cell, infoKid)">
                <igx-icon>info</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column field="name" header="Име" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="birthDate" header="Дата на раждане" [resizable]="true" [sortable]="true" [dataType]="'date'"
        [pipeArgs]="formatDateOptions" [disablePinning]="true">
    </igx-column>
    <igx-column field="gender" header="Пол" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-value>
            {{ value === 'm' ? "М" : "Ж"}}
        </ng-template>
    </igx-column>
    <igx-column field="footSize" header="Обувки №" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="height" header="Височина" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="hasDeclaration" header="Декларация" [sortable]="true" [disablePinning]="true" [resizable]="true"
        [dataType]="'boolean'"></igx-column>
    <igx-column field="allowShooting" header="Снимки" [sortable]="true" [disablePinning]="true" [resizable]="true"
        [dataType]="'boolean'"></igx-column>
    <igx-column field="notes" header="Бележки" [sortable]="true" [disablePinning]="true"
        [resizable]="true"></igx-column>
    <igx-column field="friends" header="Приятели" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseKidsArray(cell.value) }}
        </ng-template>
    </igx-column>
    <igx-column field="siblings" header="Роднини" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseKidsArray(cell.value) }}
        </ng-template>
    </igx-column>
    <igx-column field="parents" header="Родители" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseParentsArray(cell.value) }}
        </ng-template>
    </igx-column>
    <igx-column field="egn" header="ЕГН" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="morningStop" header="Спирка сутрин" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseStop(cell) }}
        </ng-template>
    </igx-column>
    <igx-column field="eveningStop" header="Спирка вечер" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseStop(cell) }}
        </ng-template>
    </igx-column>
    <igx-row-island #kidSportsGrid [key]="'sports'" primaryKey="id" [autoGenerate]="false"
        [emptyGridTemplate]="emptyRowIslandTemplate">
        <igx-grid-toolbar *igxGridToolbar="let kidSportsGrid">
            <igx-grid-toolbar-actions>
                <button igxButton igxRipple (click)="addKidSport(kidSportsGrid, sportDialog)">Добави спорт</button>
            </igx-grid-toolbar-actions>
        </igx-grid-toolbar>
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Редактирай" igxIconButton="flat" (click)="updateKidSport(cell)">
                    <igx-icon>edit</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column width="50px" [editable]="false" [resizable]="false" [pinned]="true">
            <ng-template igxCell let-cell="cell">
                <button title="Изтрий" igxIconButton="flat" (click)="deleteKidSport(cell.row)">
                    <igx-icon>delete</igx-icon>
                </button>
            </ng-template>
        </igx-column>
        <igx-column field="sport" header="Вид">
            <ng-template igxCell let-cell="cell">
                {{ cell.value.name }}
            </ng-template>
        </igx-column>
        <igx-column field="level" header="Ниво" [resizable]="true">
            <ng-template igxCell let-cell="cell">
                {{ cell.value.name ?? "" }}
            </ng-template>
        </igx-column>
    </igx-row-island>
</igx-hierarchical-grid>
<ng-template #emptyRowIslandTemplate class="empty-template-wrapper">
    <div class="empty-template-wrapper">Добави спорт</div>
</ng-template>
<igx-dialog #dialog>
    <igx-dialog-title>{{ dialogText }} дете</igx-dialog-title>
    <app-edit-kid-form #kidForm (done)="addKidDone($event, kidForm, dialog)"></app-edit-kid-form>
</igx-dialog>
<igx-dialog #sportDialog>
    <igx-dialog-title>{{ dialogText }} спорт за {{ editKidSport.kid?.name ?? ''}}</igx-dialog-title>
    <form [formGroup]="kidSportForm" (ngSubmit)="kidSportSubmit()" class="dialog">
        <igx-select formControlName="sport" (selectionChanging)="sportSelectChanging($event)">
            <label igxLabel>Спорт</label>
            <igx-select-item *ngFor="let sport of sports | sorting" [value]="sport">{{ sport.name }}</igx-select-item>
        </igx-select>
        <igx-select formControlName="level" [disabled]="levels.length < 1">
            <label *ngIf="levels.length > 0" igxLabel>Ниво</label>
            <label *ngIf="levels.length < 1" igxLabel>Изберете спорт</label>
            <igx-select-item *ngFor="let level of levels | sorting" [value]="level">{{ level.name }}</igx-select-item>
        </igx-select>
        <igx-dialog-actions>
            <button igxButton type="button" (click)="closeSportDialog(sportDialog)">ОТКАЖИ</button>
            <button igxButton type="submit">{{ dialogText }}</button>
        </igx-dialog-actions>
    </form>
</igx-dialog>
<igx-dialog #addProgram>
    <app-add-package #addPackageDialog (done)="addProgram.close()">
    </app-add-package>
</igx-dialog>
<igx-dialog #infoKid>
    <app-info-kid #infoKidDialog (done)="infoKid.close()"></app-info-kid>
</igx-dialog>